import { EOrganizationType, EUserRoles } from '@enums/common';

export const userFormTabNames = {
	basicInformation: 'Basic information',
	organisationAssignment: 'Organisation Assignment',
	assignForm: 'Assign Form',
};

export const userFormAreas = `
		"firstName lastName"
		"email contactNumber"
		"fa fa"
		"submitButtons submitButtons"
		`;

export const fixedForFirstAdminRoleTooltip
	= `You can't edit this role because there are no more Admins in your organisation`;

export const notAvailableRoleTooltip = `No access to edit this roles. Contact Platform Owner`;

export const doubleRoleTooltip = `The user must have Admin roles for all types of organizations`;

export const adminRoles: {
	role: string;
	organizationType: string;
}[] = [
	{
		role: EUserRoles.networkOperatorOrganizationAdministrator,
		organizationType: EOrganizationType.networkOperator,
	},
	{
		role: EUserRoles.assetOwnerOrganizationAdministrator,
		organizationType: EOrganizationType.assetOwner,
	},
	{
		role: EUserRoles.assetConsumerOrganizationAdministrator,
		organizationType: EOrganizationType.assetConsumer,
	},
];

export const EUserMultipleOrganisationsFormFields = {
	firstName: 'firstName',
	lastName: 'lastName',
	email: 'email',
	phoneNumber: 'phoneNumber',
	is2FA: 'is2FA',
	organisations: 'organisations',
	jobTitle: 'jobTitle',
};
